module.exports = __webpack_public_path__ + "static/media/brainIconWhite.8b323972.png";